import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let ProductVariantsMixin = class ProductVariantsMixin extends Vue {
    buildProductVariantsParams(variants) {
        const unDeleted = (variant) => {
            return !variant.isDeleted && !variant.isHidden;
        };
        return variants.filter(unDeleted).map((detail) => {
            let params = {
                productOptions: this.buildVariantProductOptions(detail.productOptions),
                published: detail.published,
                price: detail.price,
                compareAtPrice: detail.compareAtPrice,
                limited: detail.limited,
                digitalProduct: detail.digitalProduct,
                stockQuantity: Number(detail.stockQuantity) || 0,
            };
            if (detail.uuid != null) {
                params = {
                    ...params,
                    productVariantUuid: detail.uuid,
                };
            }
            return params;
        });
    }
    buildVariantProductOptions(productOptions) {
        return productOptions.map((option) => {
            let params = {
                name: option.name,
                limited: option.limited,
                stockQuantity: option.stockQuantity,
                price: option.price,
                compareAtPrice: option.compareAtPrice,
                published: option.published,
                sectionName: option.sectionName,
                digitalProduct: option.digitalProduct,
            };
            if (option.uuid != null) {
                params = {
                    ...params,
                    productOptionUuid: option.uuid,
                };
            }
            return params;
        });
    }
};
ProductVariantsMixin = __decorate([
    Component
], ProductVariantsMixin);
export default ProductVariantsMixin;
